import { render, staticRenderFns } from "./NotificationDetails.vue?vue&type=template&id=379d3aa1&scoped=true&"
import script from "./NotificationDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d3aa1",
  null
  
)

export default component.exports